import { createSelector } from '@ngrx/store';
import { selectNetworkState } from '../core.state';
import { NetworkState } from './network.state';

export const selectNetworkIsOffline = createSelector(selectNetworkState, (state: NetworkState) => state.isOffline);
export const selectNetworkIsSlow = createSelector(selectNetworkState, (state: NetworkState) => state.slowNetwork);
export const selectNetworkMonitoringActive = createSelector(selectNetworkState, (state: NetworkState) => state.monitoringActive);
